module.exports = ".box-body {\r\n    padding: 20px;\r\n    padding-top: 24px;\r\n}"